import { FETCH_OPPORTUNITY_PURPOSES_SUCCEEDED } from './opportunityPurposes.action';
import { pathOr } from 'ramda';

export const opportunityPurposesReducer = (state = [], action) => {
	switch (action.type) {
		case FETCH_OPPORTUNITY_PURPOSES_SUCCEEDED: {
			return pathOr([], ['payload', 'data'], action);
		}

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/redux/opportunityPurposes/opportunityPurposes.reducer.js